
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Shield } from 'lucide-react';

interface BlockedAccessMessageProps {
  communityName: string;
  adminContact: string | null;
}

export function BlockedAccessMessage({ communityName, adminContact }: BlockedAccessMessageProps) {
  return (
    <div className="min-h-[400px] flex items-center justify-center p-8">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
            <Shield className="h-6 w-6 text-destructive" />
          </div>
          <CardTitle className="text-2xl font-bold">Access Blocked</CardTitle>
          <CardDescription className="mt-2">
            Your access to {communityName} has been restricted by the community administrators.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-center text-muted-foreground">
            If you believe this is an error or would like to request access restoration, please contact the community administrator.
          </p>
          {adminContact && (
            <div className="text-center">
              <p className="text-muted-foreground mb-1">Contact administrator:</p>
              <a 
                href={`mailto:${adminContact}`} 
                className="text-primary hover:underline"
              >
                {adminContact}
              </a>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
